import createIcon from '../../createIcon';

/**
 * @component @name Shower
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAxOEM4LjU1MjI4IDE4IDkgMTcuNTUyMyA5IDE3QzkgMTYuNDQ3NyA4LjU1MjI4IDE2IDggMTZDNy40NDc3MiAxNiA3IDE2LjQ0NzcgNyAxN0M3IDE3LjU1MjMgNy40NDc3MiAxOCA4IDE4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyIDE4QzEyLjU1MjMgMTggMTMgMTcuNTUyMyAxMyAxN0MxMyAxNi40NDc3IDEyLjU1MjMgMTYgMTIgMTZDMTEuNDQ3NyAxNiAxMSAxNi40NDc3IDExIDE3QzExIDE3LjU1MjMgMTEuNDQ3NyAxOCAxMiAxOFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNiAxOEMxNi41NTIzIDE4IDE3IDE3LjU1MjMgMTcgMTdDMTcgMTYuNDQ3NyAxNi41NTIzIDE2IDE2IDE2QzE1LjQ0NzcgMTYgMTUgMTYuNDQ3NyAxNSAxN0MxNSAxNy41NTIzIDE1LjQ0NzcgMTggMTYgMThaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMgNS4wOFYzSDExVjUuMDhDNy42MSA1LjU3IDUgOC40NyA1IDEyVjE0SDE5VjEyQzE5IDguNDcgMTYuMzkgNS41NyAxMyA1LjA4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTggMjFDOC41NTIyOCAyMSA5IDIwLjU1MjMgOSAyMEM5IDE5LjQ0NzcgOC41NTIyOCAxOSA4IDE5QzcuNDQ3NzIgMTkgNyAxOS40NDc3IDcgMjBDNyAyMC41NTIzIDcuNDQ3NzIgMjEgOCAyMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiAyMUMxMi41NTIzIDIxIDEzIDIwLjU1MjMgMTMgMjBDMTMgMTkuNDQ3NyAxMi41NTIzIDE5IDEyIDE5QzExLjQ0NzcgMTkgMTEgMTkuNDQ3NyAxMSAyMEMxMSAyMC41NTIzIDExLjQ0NzcgMjEgMTIgMjFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTYgMjFDMTYuNTUyMyAyMSAxNyAyMC41NTIzIDE3IDIwQzE3IDE5LjQ0NzcgMTYuNTUyMyAxOSAxNiAxOUMxNS40NDc3IDE5IDE1IDE5LjQ0NzcgMTUgMjBDMTUgMjAuNTUyMyAxNS40NDc3IDIxIDE2IDIxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Shower = createIcon('Shower', [
  [
    'path',
    {
      d: 'M8 18C8.55228 18 9 17.5523 9 17C9 16.4477 8.55228 16 8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18Z',
      key: '1yzagn',
    },
  ],
  [
    'path',
    {
      d: 'M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z',
      key: '4vwfh1',
    },
  ],
  [
    'path',
    {
      d: 'M16 18C16.5523 18 17 17.5523 17 17C17 16.4477 16.5523 16 16 16C15.4477 16 15 16.4477 15 17C15 17.5523 15.4477 18 16 18Z',
      key: '1eu4y1',
    },
  ],
  [
    'path',
    {
      d: 'M13 5.08V3H11V5.08C7.61 5.57 5 8.47 5 12V14H19V12C19 8.47 16.39 5.57 13 5.08Z',
      key: '1p6d9n',
    },
  ],
  [
    'path',
    {
      d: 'M8 21C8.55228 21 9 20.5523 9 20C9 19.4477 8.55228 19 8 19C7.44772 19 7 19.4477 7 20C7 20.5523 7.44772 21 8 21Z',
      key: '1tdrst',
    },
  ],
  [
    'path',
    {
      d: 'M12 21C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21Z',
      key: '12ey4v',
    },
  ],
  [
    'path',
    {
      d: 'M16 21C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21Z',
      key: 'uvkqim',
    },
  ],
]);

export default Shower;
